import React from 'react'
import { ReactComponent as ChevronIcon } from 'assets/icons/cheveron-down.svg'
import s from './styles/Section.module.scss'

export const Section = ({
	icon: Icon,
	title,
	subtitle,
	count,
	open,
	onToggle,
	actions,
	leadingActions,
	children,
}) => {
	const handleKeyDown = event => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			onToggle()
		}
	}

	const hasToolbar = Boolean(leadingActions || actions)

	return (
		<section className={s.section}>
			<div className={s.head}>
				<div
					className={s.content}
					role="button"
					tabIndex={0}
					onClick={onToggle}
					onKeyDown={handleKeyDown}
				>
					{Icon ? (
						<span className={s.icon}>
							<Icon aria-hidden />
						</span>
					) : null}
					<div className={s.inner}>
						<div className={s.row}>
							<h2 className={s.title}>{title}</h2>
							{count != null ? <span className={s.count}>{count}</span> : null}
						</div>
						{subtitle ? <p className={s.subtitle}>{subtitle}</p> : null}
					</div>
				</div>

				{hasToolbar ? (
					<div className={s.headToolbar} onClick={event => event.stopPropagation()}>
						{leadingActions}
						{actions}
					</div>
				) : null}

				<button
					type="button"
					className={s.toggle}
					onClick={onToggle}
					aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
					aria-expanded={open}
				>
					<ChevronIcon className={open ? s.chevronUp : s.chevronDown} aria-hidden />
				</button>
			</div>
			{open ? children : null}
		</section>
	)
}

export default Section
